import { h, Component, RenderableProps } from 'preact';
import { Board }  from '../lib/vowelboard'
import { BoardPosition } from '../lib/wordboard';
import { pointerDragManager, DragManagerUnsubscribe } from '../lib/touchhelper'

interface LetterTileProps { 
    x: number, 
    y: number, 
    letter: string, 
    selected: boolean,
    count: number
}

export function LetterTile( { letter, selected, count}: RenderableProps<LetterTileProps>) {
    var inner = selected ? <b> { letter } </b> :  letter 
//<span class="count">{count}</span>
    return (   
        <span class={"letter-tile" + (selected ? " selected" : "") + (count == 0 ? " zero": "") } >
        { letter }
        </span> 
    )
}

interface LetterGridProps {
    selectedLetters: BoardPosition[]
    letters: string[][]
    counts?: number[][]
    onTrySelectLetter?: (row:number, col: number, letter: string) => void
}

export class LetterGrid extends Component<LetterGridProps,{}>  {

    letters: Map<number, Component<LetterTileProps>>;

    dragSubscriptions: DragManagerUnsubscribe[] = [];

    constructor() {
        super();
        this.letters = new Map();
    }

    componentDidMount() {
        this.dragSubscriptions.push(pointerDragManager.onDragMove(this.handlePointerDrag));
        this.dragSubscriptions.push(pointerDragManager.onDragStart(this.handlePointerClick));
    }

    componentWillUnmount() {
        this.dragSubscriptions.forEach(unsub => unsub());
        this.dragSubscriptions = [];
    }
    
    handlePointerClick = (pageX: number, pageY: number): boolean => {
        this.doTrySelectLetterAt(pageX, pageY);
        return true;
    }

    doTrySelectLetterAt(pageX: number, pageY: number) {
        if (!this.props.onTrySelectLetter) return;
        const eventInBounds = (r:DOMRect | ClientRect ):boolean => {
            let centerX = r.left + (r.width/2);
            let centerY = r.top + (r.height/2);
            let radius = r.width/2;

            let distSquared = ((pageX-centerX) * (pageX-centerX)) + ((pageY-centerY) * (pageY-centerY));
            let radiusSquared = radius * radius;
            return distSquared <= radiusSquared;
        }
        var letterComponent  = [...this.letters.values()].find(l=>l.base && eventInBounds(l.base.getBoundingClientRect()))
        if (letterComponent) 
            this.props.onTrySelectLetter(letterComponent.props.y, letterComponent.props.x, letterComponent.props.letter)
    }

    handlePointerDrag = (pageX: number, pageY: number): boolean => {
        if (!this.props.onTrySelectLetter) return true;
        this.doTrySelectLetterAt(pageX, pageY);
        return false; //always false for drag, to work around annoying ios behaviour.
    }

    render({ letters, selectedLetters, counts }:LetterGridProps): JSX.Element {
        let letterWidgets = letters.map( 
            (row, rownum) => row.map( 
                (letter, colnum) => (
                    <LetterTile ref={x =>this.letters.set(rownum * 1000 + colnum, x)} x={colnum} y={rownum} letter={letter} count={counts ? counts[rownum][colnum]: 1} selected={selectedLetters.find(l => l.Row == rownum && l.Col == colnum) != null }></LetterTile> 
                ) 
            )
        )

        return (
        <div class={"letter-grid cols-" + letters[0].length} >
            { letterWidgets }  
        </div>
        )
    }
}
